import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const resolvingParentingIssues: BlogMetaData = {
  title: '子育て悩みランキングTOP10と解決法｜モンテッソーリ視点で年齢別に解説',
  description:
    '子育てで悩みやすい10のテーマ（イヤイヤ期・癇癪・夜泣き・トイトレ・育児疲れなど）をランキングでまとめ、原因と対処法を解説した記事へのリンクを紹介します。モンテッソーリ視点の考え方も解説。',
  thumbnailUrl: '/img/blog-resolving-parenting-issues.webp',
  filePath: buildBlogFilePath('resolving-parenting-issues'),
  category: BLOG_CATEGORY.INTRODUCTION,
};
